export const OLD_ANDROID_UPGRADED = 'OLD_ANDROID_UPGRADED';
export const UPGRADE_APP_VERSION = 'UPGRADE_APP_VERSION';
